import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-flooring',
    templateUrl: './icon-flooring.component.html'
})
export class IconFlooringComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
